module.exports = __webpack_public_path__ + "static/media/featureGraphic.4cdd3221.png";